import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import Loader from "../../../core/common/selfLoder";

const insuranceCards = [
  {
    name: "Policy Information",
    logo: "https://team1consulting.com/weconnect/assets/img/icons/info.png",
    link: "/policy-information",
  },
  {
    name: "Customer Information Sheet",
    logo: "https://team1consulting.com/weconnect/assets/img/icons/paper.png",
    link: "/customer-information-sheet",
  },
  {
    name: "Claim Procedures",
    logo: "https://team1consulting.com/weconnect/assets/img/icons/claim.png",
    link: "/claim-procedures",
  },
  {
    name: "Coverages",
    logo: "https://team1consulting.com/weconnect/assets/img/icons/insurance-coverages.png",
    link: "/my-coverages",
  },
  {
    name: "GPA-Key Information",
    logo: "https://team1consulting.com/weconnect/assets/img/icons/folders.png",
    link: "/GPA-key-information",
  },
  {
    name: "Premium Eligibility",
    logo: "https://team1consulting.com/weconnect/assets/img/icons/premium.png",
    link: "/premium-eligibility",
  },
  {
    name: "Hospital Network List",
    logo: "https://team1consulting.com/weconnect/assets/img/icons/health-insurance.png",
    link: "https://www.icicilombard.com/cashless-hospitals",
    external: true,
  },
  {
    name: "Grievance",
    logo: "https://team1consulting.com/weconnect/assets/img/icons/complain.png",
    link: "/grievance",
  },
  {
    name: "FAQs",
    logo: "https://team1consulting.com/weconnect/assets/img/icons/faq.png",
    link: "https://team1consulting.com/weconnect/medical-insurance/GMC-PPT-Team-1.pdf",
    external: true,
  },
];

const HealthInsuranceCorner = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timeout);
  }, []);
  return (
    <>
      <Loader loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Health Insurance</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/employee-dashboard">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Insurance / Health Insurance
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}

          <div className="row h-100">
            {insuranceCards.map((card, index) => (
              <div key={index} className="col-6 col-md-4 col-lg-3 mb-3">
                {card.external ? (
                  <a
                    href={card.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-100"
                  >
                    <div className="h-100 card shadow-sm p-2 p-md-4 d-flex flex-column align-items-center justify-content-center text-center">
                      <img
                        src={card.logo}
                        alt={card.name}
                        className="mb-3"
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "contain",
                        }}
                      />
                      <h5 className="mb-0">{card.name}</h5>
                    </div>
                  </a>
                ) : (
                  <Link to={card.link} className="w-100">
                    <div className="h-100 card shadow-sm p-2 p-md-4 d-flex flex-column align-items-center justify-content-center text-center">
                      <img
                        src={card.logo}
                        alt={card.name}
                        className="mb-3"
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "contain",
                        }}
                      />
                      <h5 className="mb-0">{card.name}</h5>
                    </div>
                  </Link>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default HealthInsuranceCorner;
